// Edit names, text, images and links of the four sections here.
// `url` can be an internal path ("/more") or a full link to a live app.
export const SITE = {
  name: "PetTok Shop",
  domain: "pettokshop.net",
  tagline: "Treats, toys and gear tested by Kiddee, our toy-obsessed rat terrier.",
  heroImage: "/media/kiddee/1.jpg",
  socials: [
    { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@mrscott_1000000" },
    { id: "instagram", label: "Instagram", url: "https://www.instagram.com/pettokshop" },
    { id: "facebook", label: "Facebook", url: "https://www.facebook.com/pettokshop" },
  ],
};

// From the public business listing; add the street address when known.
export const STORE = {
  address: "Hemet, California 92543",
  email: "pettokshop@pettokshop.net",
};

export const SECTIONS = [
  {
    id: "shop",
    title: "Shop",
    tagline: "Treats, toys, beds and harnesses",
    icon: "ShoppingBag",
    accent: "#E06D44",
    url: "/shop",
    image: "/media/training-treats-bundle.jpg",
  },
  {
    id: "guide",
    title: "Free Guide",
    tagline: "The first 30 days with a new dog or cat",
    icon: "BookOpen",
    accent: "#0D9488",
    url: "/guide",
    image: "/media/kiddee/7.jpg",
  },
  {
    id: "collab",
    title: "Creator Collabs",
    tagline: "Your pet's famous. Get paid for it.",
    icon: "Sparkles",
    accent: "#4E7B68",
    url: "/collab",
    image: "/media/kiddee/5.jpg",
  },
  {
    id: "portraits",
    title: "Memorial Portraits",
    tagline: "Watercolor portraits of the pets you miss",
    icon: "Brush",
    accent: "#8B5CF6",
    url: "https://bramblepaw-studio.polsia.io/",
    image: "https://cdn.polsia.com/company_982334/chat/9fdfa613-ba3c-427d-bb48-4f4caa6fbffa.jpg",
  },
];

export const KIDDEE = {
  video: "/media/kiddee.mp4?v=2",
  photos: [2, 3, 4, 6].map((n) => `/media/kiddee/${n}.jpg`),
  story: [
    "Kiddee is a 4-year-old rat terrier with strong opinions and zero chill. She's our Chief Treat Tester, and every product on PetTok Shop has to get past her before it earns a spot on the shelf.",
    "Scott packs the shop. Kiddee quality-controls it. You're buying from a person and his dog, not a faceless warehouse. If she turns her nose up, it doesn't get listed.",
  ],
};
